import { store } from 'store';
import { userType } from 'utils';
import { getLocalStorage } from 'utils/cookies-util';

export const pageLimitOptions = [10, 20, 50, 100, 150];

export const avatarColors = ['#7EBCE6', '#FBB13C', '#FECACA', '#F3D34A'];

export const defaultAvatarColors = () =>
  getLocalStorage('theme') === 'dark' && userType() === 'admin'
    ? ['#A0D9111A', '#FAAD141A', '#1677FF1A', '#13C2C21A']
    : avatarColors;

export const themeOptions = () => {
  const lightCssVariables = store?.getState()?.tenantConfigData?.tenantData?.style_sheet?.light_css_variables;
  const darkCssVariables = store?.getState()?.tenantConfigData?.tenantData?.style_sheet?.dark_css_variables;

  return [
    {
      name: 'light',
      colorConfig: {
        '--user-primary-light': lightCssVariables?.['user-primary-light'] || '#0778821a',
        '--user-primary-dark': lightCssVariables?.['user-primary-dark'] || '#00434d',
        '--bg-main': 'white',
        '--text-main': 'black',
        '--user-main-red': '#f5222d',
        '--user-main-red-light': '#f5222d1a',
        '--user-neutral-2': '#f5f5f5',
        '--user-inner-card-bg': '#F8F8F8',
        '--user-dropdown-bg': '#FFFFFF',
        '--user-card-bg': 'transparent',
        '--user-neutral-3': '#f5f5f5',
        '--user-neutral-4': '#d9d9d9',
        '--user-main-text': '#434343',
        '--user-card-border': '#d9d9d9',
        '--user-border-dark': '#E6E6E7',
        '--user-border-light': '#F0F0F0',
        '--user-table-bg': 'white',
        '--user-border-checkbox': '#d9d9d9',
        '--scroll-bar-bg': '#b6afafff',
        '--user-main-blue': '#096dd9',
        '--user-main-blue-light': '#096dd91a',
        '--user-chip-bg': '#F8F8F8',
        '--user-navbar-border': '#F0F0F0',
        '--user-bg': '#f5f5f5',
        '--user-main-green': '#24a147',
        '--user-main-green-light': '#e7f2ea',
        '--user-main-orange': '#fb5607',
        '--user-main-orange-light': '#fb56071a',
        '--user-disabled-field': '#f9fafb',
        '--user-icon-bg': 'white',
        '--user-junction-icon': '#3D1836',
        '--spin-button-filter': 'none',
        '--user-modal-bg': '#ffffff',
        '--user-pill-bg': '#F0F0F0',
        '--user-icon-border': '#D9D9D9',
      },
    },
    {
      name: 'dark',
      colorConfig: {
        '--user-primary-light': darkCssVariables?.['user-primary-light'] || '#122627',
        '--user-primary-dark': darkCssVariables?.['user-primary-dark'] || '#00434d',
        '--bg-main': '#161616',
        '--text-main': '#EAEAEA',
        '--user-main-red': '#E57373',
        '--user-main-red-light': '#E573731A',
        '--user-neutral-2': 'rgba(245, 245, 245, 0.2)',
        '--user-inner-card-bg': '#262626',
        '--user-neutral-3': '#8C8C8C',
        '--user-dropdown-bg': '#262626',
        '--user-card-bg': '#1C1C1C',
        '--user-neutral-4': '#2C2C2C',
        '--user-main-text': '#8C8C8C',
        '--user-card-border': 'transparent',
        '--user-border-dark': '#1C1C1C',
        '--user-border-light': '#434343',
        '--user-table-bg': '#1C1C1C',
        '--user-border-checkbox': '#8C8C8C',
        '--scroll-bar-bg': '#8C8C8C',
        '--user-main-blue': '#0a58eb',
        '--user-main-blue-light': '#0a58eb1a',
        '--user-chip-bg': '#1C1C1C',
        '--user-navbar-border': '#2C2C2C',
        '--user-bg': '#161616',
        '--user-main-green': '#1BAE85',
        '--user-main-green-light': '#1BAE851A',
        '--user-main-orange': '#FF6A1A',
        '--user-main-orange-light': '#FF6A1A1A',
        '--user-disabled-field': '#434343',
        '--user-icon-bg': '#1C1C1C',
        '--user-junction-icon': '#FFFFFF',
        '--spin-button-filter': 'invert(1) brightness(1.8)',
        '--user-modal-bg': '#1F1F1F',
        '--user-pill-bg': '#262626',
        '--user-icon-border': '#434343',
      },
    },
  ];
};

export const GENDER_OPTIONS = [
  {
    id: 'male',
    value: 'male',
    slug: 'male',
    label: 'Male',
    name: 'Male',
  },
  {
    id: 'female',
    value: 'female',
    slug: 'female',
    label: 'Female',
    name: 'Female',
  },
];

export const LABS_DISTANCE_OPTIONS = [
  {
    id: '10',
    value: '10',
    slug: '10',
    label: '10 meters',
    name: '10 meters',
  },
  {
    id: '20',
    value: '20',
    slug: '20',
    label: '20 meters',
    name: '20 meters',
  },
  {
    id: '25',
    value: '25',
    slug: '25',
    label: '25 meters',
    name: '25 meters',
  },
  {
    id: '50',
    value: '50',
    slug: '50',
    label: '50 meters',
    name: '50 meters',
  },
  {
    id: '100',
    value: '100',
    slug: '100',
    label: '100 meters',
    name: '100 meters',
  },
];

export const ORDER_TYPES = [
  {
    value: 'order',
    name: 'Order',
    slug: 'order',
    label: 'Order',
    id: 'order',
  },
  {
    value: 'subscription',
    name: 'Subscription',
    slug: 'subscription',
    label: 'Subscription',
    id: 'subscription',
  },
  {
    value: 'multi_subscription',
    name: 'Multi Subscription',
    slug: 'multi_subscription',
    label: 'Multi Subscription',
    id: 'multi_subscription',
  },
];

export const BOOLEAN_OPTIONS = [
  { id: 'true', slug: 'true', name: 'Yes', value: 'true' },
  { id: 'false', slug: 'false', name: 'No', value: 'false' },
];

export const quarterOptions = [1, 2, 3, 4, 5].map((q) => ({
  id: String(q),
  slug: String(q),
  name: String(q),
  value: String(q),
  label: String(q),
}));

export const ACTION_TYPE_OPTIONS = [
  { id: 'Credited', slug: 'credited', name: 'Credited', label: 'Credited', value: 'Credited' },
  { id: 'Debited', slug: 'debited', name: 'Debited', label: 'Debited', value: 'Debited' },
];

export const LEAVE_STATUSES = Object.freeze({
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
});
